import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';

// Public outer shell
import PublicLayout from '@/components/PublicLayout';
import Landing    from '@/pages/public/Landing';
import About      from '@/pages/public/About';
import Enterprise from '@/pages/public/Enterprise';
import LoginPage  from '@/pages/public/Login';

// Inner workspace
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout     from '@/components/Layout';
import Overview   from '@/pages/Overview';
import Canon      from '@/pages/Canon';
import SourceDetail from '@/pages/SourceDetail';
import Brain      from '@/pages/Brain';
import FindingDetail from '@/pages/FindingDetail';
import Evidence   from '@/pages/Evidence';
import Sentinel   from '@/pages/Sentinel';
import Audit      from '@/pages/Audit';
import IngestionArtifact from '@/pages/IngestionArtifact';
import Lifecycle from '@/pages/Lifecycle';
import Connectors from '@/pages/Connectors';
import Security from '@/pages/Security';

// Redirect legacy flat routes → /app/* with params
function ParamRedirect({ base }) {
  const params = useParams();
  return <Navigate to={`${base}/${params.id}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── Public outer shell ── */}
        <Route element={<PublicLayout />}>
          <Route path="/"           element={<Landing />} />
          <Route path="/about"      element={<About />} />
          <Route path="/enterprise" element={<Enterprise />} />
          <Route path="/login"      element={<LoginPage />} />
        </Route>

        {/* ── Inner workspace (session-gated) ── */}
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/app/overview" replace />} />
          <Route path="overview"    element={<Overview />} />
          <Route path="canon"       element={<Canon />} />
          <Route path="canon/:id"   element={<SourceDetail />} />
          <Route path="brain"       element={<Brain />} />
          <Route path="brain/:id"   element={<FindingDetail />} />
          <Route path="evidence"    element={<Evidence />} />
          <Route path="sentinel"    element={<Sentinel />} />
          <Route path="audit"       element={<Audit />} />
          <Route path="artifact/:id" element={<IngestionArtifact />} />
          <Route path="lifecycle"    element={<Lifecycle />} />
          <Route path="connectors"   element={<Connectors />} />
          <Route path="security"     element={<Security />} />
        </Route>

        {/* ── Legacy flat-route compat redirects ── */}
        <Route path="/overview"      element={<Navigate to="/app/overview" replace />} />
        <Route path="/canon"         element={<Navigate to="/app/canon" replace />} />
        <Route path="/canon/:id"     element={<ParamRedirect base="/app/canon" />} />
        <Route path="/brain"         element={<Navigate to="/app/brain" replace />} />
        <Route path="/brain/:id"     element={<ParamRedirect base="/app/brain" />} />
        <Route path="/evidence"      element={<Navigate to="/app/evidence" replace />} />
        <Route path="/sentinel"      element={<Navigate to="/app/sentinel" replace />} />
        <Route path="/audit"         element={<Navigate to="/app/audit" replace />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
